import './QRInput.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useRef, useState } from 'react';
import QRCode from '../../api/controllers/QRCode/QRCode';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Modal from '../Modal/Modal';
import EditBay from '../EditBay/EditBay';
import Hub from '../../api/controllers/Hub/Hub';
import Packages from '../../api/controllers/Packages/Packages';

const QRInput = ({ onScan }) => {
  const [code, setCode] = useState();
  const [codeSubmitted, setCodeSubmitted] = useState(false);
  const [placeholder, setPlaceholder] = useState('Scan Code');

  const [modalOpen, setModalOpen] = useState();
  const [scannedPackage, setScannedPackage] = useState();
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();
  const [error, setError] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;
  const navigate = useNavigate();

  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };

  const [QRCodeRef, setQRCodeFocus] = UseFocus();

  document.addEventListener('keydown', event => {
    if (
      event.target.tagName !== 'INPUT' &&
      event.target.tagName !== 'TEXTAREA' &&
      ![
        'Control',
        'Meta',
        'Alt',
        'Backspace',
        'Tab',
        'CapsLock',
        'Shift',
        'Escape',
        'Enter',
        'ArrowUp',
        'ArrowRight',
        'ArrowLeft',
        'ArrowDown',
      ].includes(event.key)
    ) {
      setQRCodeFocus();
    }
  });

  const submitCode = e => {
    e.preventDefault();

    QRCode.decode(code)
      .then(response => {
        if (onScan) {
          onScan(response);
        } else {
          handleScan(response);
        }
        setCode('');
      })
      .catch(e => {
        setCode('');
        setCodeSubmitted(true);
        setPlaceholder(e.error);
      });
  };

  const handleScan = response => {
    switch (response.category) {
      case 'bay':
        if (response.hubId == hubId) {
          navigate(`/bays/${response.id}`);
        } else {
          setCodeSubmitted(true);
          setPlaceholder('QR code invalid for this hub');
        }
        break;
      case 'job':
        if (response.originHubId == hubId || response.destinationHubId == hubId) {
          navigate(`/jobs/${response.id}`);
        } else {
          setCodeSubmitted(true);
          setPlaceholder('QR code invalid for this hub');
        }
        break;
      case 'package':
        if (response.hubId == hubId && response.status == 'in_warehouse') {
          handleSetBay(response);
        } else if (response.hubId == hubId && response.status == 'complete') {
          navigate(`/jobs/${response.jobId}`);
        } else {
          setCodeSubmitted(true);
          setPlaceholder('QR code invalid for this hub');
        }
        break;
      case 'domestic':
        if (response.destinationHubId == hubId) {
          navigate(`/collections/${response.id}`);
        } else if (response.originHubId == hubId) {
          navigate(`/deliveries/${response.id}`);
        } else {
          setCodeSubmitted(true);
          setPlaceholder('QR code invalid for this hub');
        }
        break;
      case 'subcontracted':
        if (response.destinationHubId == hubId) {
          navigate(`/subcontracts_in/${response.id}`);
        } else if (response.originHubId == hubId) {
          navigate(`/subcontracts_out/${response.id}`);
        } else {
          setCodeSubmitted(true);
          setPlaceholder('QR code invalid for this hub');
        }
        break;
      case 'international':
        if (response.destinationHubId == hubId) {
          navigate(`/imports/${response.id}`);
        } else if (response.originHubId == hubId) {
          navigate(`/exports/${response.id}`);
        } else {
          setCodeSubmitted(true);
          setPlaceholder('QR code invalid for this hub');
        }
        break;
      default:
        setCodeSubmitted(true);
        setPlaceholder('QR code invalid for this hub');
        break;
    }
  };

  const handleSetBay = async pkg => {
    await Hub.show(hubId)
      .then(response => {
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
      })
      .catch(e => {
        setError(e.errors || e.error);
      });

    await Packages.show(pkg.id)
      .then(response => {
        setScannedPackage(response);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });

    setModalOpen(true);
  };

  return (
    <>
      <form className="qr_container" onSubmit={submitCode}>
        <div className="qr_icon_container">
          <FontAwesomeIcon className="qr_icon" icon={faQrcode} data-testid={'qr_icon'} />
        </div>
        <div
          className={`qr_input_container ${codeSubmitted && 'value_given'}`}
          data-testid={'qr_input_container'}
        >
          <input
            placeholder={placeholder}
            value={code}
            onChange={e => {
              setCodeSubmitted(false);
              setPlaceholder('Scan Code');
              setCode(e.target.value);
            }}
            ref={QRCodeRef}
            data-testid="input_qrcode"
          />
        </div>
        <button className="qr_button_container" type="submit">
          <FontAwesomeIcon
            className="qr_submit_icon"
            icon={faCircleArrowRight}
            data-testid={'qr_submit_icon'}
          />
        </button>
      </form>
      {modalOpen && (
        <Modal
          title={'Select Bay'}
          setModalOpen={setModalOpen}
          content={
            <EditBay
              overrideError={error}
              bays={bays}
              refetchPackages={() => {}}
              racks={racks}
              setModalOpen={setModalOpen}
              packages={[
                {
                  packageName: `${scannedPackage?.job?.jobReference}-${scannedPackage?.packageNumber}`,
                  package: scannedPackage,
                },
              ]}
            />
          }
        />
      )}
    </>
  );
};

QRInput.propTypes = {
  onScan: PropTypes.func,
};

export default QRInput;
